import { ReturnDetails } from "../../../../returns.types";
import { DownloadDetailsBtn } from "./DownloadDetailsBtn";

import styles from "../ReturnModal.module.scss";

export const ReturnFooter = ({
  returnDetails
}: {
  returnDetails?: ReturnDetails;
}) => {
  return (
    <div className={styles.returnModal_download}>
      <DownloadDetailsBtn returnDetails={returnDetails as ReturnDetails} />
    </div>
  );
};
